export const data = [
  {
    change: '9. Rent for special occasions',
    pounds: 3
  },
  {
    change: '8. Skip dry cleaning',
    pounds: 5
  },
  {
    change: '7. Repair one garment a season',
    pounds: 19
  },
  {
    change: '6. Choose mostly standard shipping',
    pounds: 24
  },
  {
    change: '5. Wash clothes on cold',
    pounds: 43
  },
  {
    change: '4. Wear dresses at least 12 times',
    pounds: 60
  },
  {
    change: '3. Shop mostly sustainable brands',
    pounds: 233
  },
  {
    change: '2. Air dry clothes',
    pounds: 447
  },
  {
    change: '1. Buy mostly secondhand clothes',
    pounds: 527
  }
];
